/**
 * tdesign v0.44.2
 * (c) 2022 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-74ef9ead.js';
import React from 'react';
import { render } from '../_util/react-render.js';
import Dialog from './Dialog.js';
import { getAttach } from '../_util/dom.js';
import '../_common/js/log/index.js';
import log from '../_common/js/log/log.js';
import '../_chunks/dep-d07435ee.js';
import '../_chunks/dep-7a9656a6.js';
import '../_chunks/dep-dfae10c3.js';
import 'react-dom';
import '../_chunks/dep-5e9bbb71.js';
import '../_chunks/dep-784849f3.js';
import '../_chunks/dep-d6cc3db8.js';
import '../_chunks/dep-10140b37.js';
import '../_chunks/dep-da112583.js';
import '../_chunks/dep-1792ab93.js';
import '../_chunks/dep-1e4c771d.js';
import '../_chunks/dep-f4495ac9.js';
import '../_chunks/dep-670cc86e.js';
import '../_chunks/dep-6c09308a.js';
import 'tdesign-icons-react';
import '../locale/LocalReceiver.js';
import '../config-provider/index.js';
import '../config-provider/ConfigProvider.js';
import '../_chunks/dep-5eadc4f3.js';
import '../_chunks/dep-fd215ab0.js';
import '../_chunks/dep-8127363b.js';
import '../_chunks/dep-a0b71ae4.js';
import '../_chunks/dep-4ca52001.js';
import '../_chunks/dep-408df89a.js';
import '../_chunks/dep-e755a9cb.js';
import '../_chunks/dep-15d0e734.js';
import '../_chunks/dep-b0c02324.js';
import '../_chunks/dep-a09b6dac.js';
import '../_chunks/dep-9c2f4c72.js';
import '../_chunks/dep-da7344ec.js';
import '../_chunks/dep-01fe0fd1.js';
import '../_chunks/dep-20a8e46d.js';
import '../_chunks/dep-9d067299.js';
import '../config-provider/ConfigContext.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../_common/js/global-config/default-config.js';
import '../button/index.js';
import '../button/Button.js';
import 'classnames';
import '../hooks/useConfig.js';
import '../hooks/useDomRefCallback.js';
import '../_util/useRipple.js';
import '../_util/useAnimation.js';
import '../_util/setStyle.js';
import '../loading/index.js';
import '../loading/Loading.js';
import '../common/Portal.js';
import '../loading/gradient.js';
import '../_common/js/loading/circle-adapter.js';
import '../_common/js/utils/set-style.js';
import '../_common/js/utils/helper.js';
import '../_chunks/dep-0508545e.js';
import '../loading/defaultProps.js';
import 'raf';
import '../_util/easing.js';
import '../loading/plugin.js';
import '../loading/style/index.js';
import '../loading/type.js';
import '../button/defaultProps.js';
import '../_util/parseTNode.js';
import '../button/style/index.js';
import '../button/type.js';
import '../_util/noop.js';
import './RenderDialog.js';
import 'react-transition-group';
import '../_util/useDialogEsc.js';
import './defaultProps.js';
import './hooks/useLockStyle.js';
import '../_util/useLayoutEffect.js';
import '../_common/js/utils/getScrollbarWidth.js';
import '../_util/useSetState.js';
import '../hooks/useGlobalIcon.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var createDialog = function createDialog(props) {
  var dialogRef = /*#__PURE__*/React.createRef();
  var options = _objectSpread({}, props);
  var fragment = document.createDocumentFragment();
  render( /* @__PURE__ */React.createElement(Dialog, _objectSpread(_objectSpread({}, options), {}, {
    visible: true,
    ref: dialogRef,
    isPlugin: true
  })), fragment);
  var container = getAttach(options.attach);
  if (container) {
    container.appendChild(fragment);
  } else {
    log.error("Dialog", "attach is not exist");
  }
  var dialogNode = {
    show: function show() {
      requestAnimationFrame(function () {
        var _dialogRef$current;
        container.appendChild(fragment);
        (_dialogRef$current = dialogRef.current) === null || _dialogRef$current === void 0 ? void 0 : _dialogRef$current.show();
      });
    },
    hide: function hide() {
      requestAnimationFrame(function () {
        var _dialogRef$current2;
        (_dialogRef$current2 = dialogRef.current) === null || _dialogRef$current2 === void 0 ? void 0 : _dialogRef$current2.destroy();
      });
    },
    update: function update(updateOptions) {
      requestAnimationFrame(function () {
        var _dialogRef$current3;
        (_dialogRef$current3 = dialogRef.current) === null || _dialogRef$current3 === void 0 ? void 0 : _dialogRef$current3.update(updateOptions);
      });
    },
    destroy: function destroy() {
      requestAnimationFrame(function () {
        var _dialogRef$current4;
        (_dialogRef$current4 = dialogRef.current) === null || _dialogRef$current4 === void 0 ? void 0 : _dialogRef$current4.destroy();
      });
    }
  };
  return dialogNode;
};
var confirm = function confirm(props) {
  return createDialog(props);
};
var alert = function alert(props) {
  var options = _objectSpread({}, props);
  options.cancelBtn = null;
  return createDialog(options);
};
createDialog.alert = alert;
createDialog.confirm = confirm;
var DialogPlugin = createDialog;

export { DialogPlugin };
//# sourceMappingURL=plugin.js.map
